import React from 'react';
import { PageTitleZoneNext } from '../../../../components/page-title-zone';
import { CitizenNameDisplay } from '../../../../components/display/citizen-name-display';

interface IPrintScheduleTitlezoneProps {
  title: string;
}

export function PrintScheduleTitlezone({ title }: Readonly<IPrintScheduleTitlezoneProps>) {
  return <PageTitleZoneNext isLoading={false} entityName="Borgers skema" title={title} subtitle={<CitizenNameDisplay />} />;
}
